// src/app/utils/date.service.ts
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DateService {
  updateEndDate(startDate: string | Date, period: number): string | null {
    if (!startDate || !period) {
      console.error('Missing startDate or period');
      return null;
    }

    const endDate = new Date(startDate);
    endDate.setFullYear(endDate.getFullYear() + period);
    endDate.setMinutes(endDate.getMinutes() - 1);
    return this.formatDate(endDate);
  }

  private validateAndConvertDate(date: string | Date): Date | null {
    if (!date) return null;

    let dateObject: Date;
    if (typeof date === 'string') {
      dateObject = new Date(date);
    } else {
      dateObject = date;
    }

    if (!(dateObject instanceof Date) || isNaN(dateObject.getTime())) {
      console.error('Invalid date:', date);
      return null;
    }

    return dateObject;
  }

  private getFormattedDateParts(date: Date) {
    try {
      return {
        minutes: date.getMinutes().toString().padStart(2, '0'),
        hours: date.getHours().toString().padStart(2, '0'),
        day: date.getDate().toString().padStart(2, '0'),
        month: (date.getMonth() + 1).toString().padStart(2, '0'),
        year: date.getFullYear(),
      };
    } catch (error) {
      console.error('Error formatting date:', error);
      return null;
    }
  }

  // Original functions using the helper methods
  formatDate(date: string | Date): string {
    const dateObject = this.validateAndConvertDate(date);
    if (!dateObject) return '';

    const parts = this.getFormattedDateParts(dateObject);
    if (!parts) return '';

    return `${parts.day}/${parts.month}/${parts.year} ${parts.hours}:${parts.minutes}`;
  }

  formatDate2(date: string | Date): string {
    const dateObject = this.validateAndConvertDate(date);
    if (!dateObject) return '';

    const parts = this.getFormattedDateParts(dateObject);
    if (!parts) return '';

    return `${parts.day}/${parts.month}/${parts.year}-${parts.hours}:${parts.minutes}`;
  }

  formatDateProfile(date: string | Date): string {
    const dateObject = this.validateAndConvertDate(date);
    if (!dateObject) return '';

    const parts = this.getFormattedDateParts(dateObject);
    if (!parts) return '';

    return `${parts.day}/${parts.month}/${parts.year}`;
  }

  formatDatePayment(date: string | Date): string {
    const dateObject = this.validateAndConvertDate(date);
    if (!dateObject) return '';

    const parts = this.getFormattedDateParts(dateObject);
    if (!parts) return '';

    return `${parts.day}${parts.month}${parts.year}${parts.hours}${parts.minutes}`;
  }

  formatDateVcx(date: string | Date): string {
    const dateObject = this.validateAndConvertDate(date);
    if (!dateObject) return '';

    const parts = this.getFormattedDateParts(dateObject);
    if (!parts) return '';

    return `${parts.year}-${parts.month}-${parts.day} ${parts.hours}:${parts.minutes}`;
  }

  //   const input1 = "21/04/2026 23:59";
  // console.log(formatEndDateVcx(input1)); // Output: "2026-04-21 23:59"
  formatEndDateVcx(dateString: string): string {
    if (!dateString) return '';

    try {
      const [datePart, timePart] = dateString.split(' ');
      if (!datePart || !timePart) return '';
      const [day, month, year] = datePart.split('/');
      if (!day || !month || !year) return '';
      // Tạo chuỗi mới với định dạng YYYY-MM-DD HH:MM
      return `${year}-${month.padStart(2, '0')}-${day.padStart(
        2,
        '0'
      )} ${timePart}`;
    } catch (error) {
      console.error('Lỗi định dạng ngày tháng:', error);
      return '';
    }
  }
}
